import { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import TireInventory from '../components/TireInventory';
import Reviews from '../components/Reviews';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LandingPage = () => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const initializePage = async () => {
      // Seed the database on first load
      try {
        await axios.post(`${API}/seed`);
      } catch (error) {
        console.log('Database already seeded or error:', error);
      }
      
      // Fetch site settings
      try {
        const response = await axios.get(`${API}/settings`);
        setSiteSettings(response.data);
      } catch (error) {
        console.log('Failed to fetch settings:', error);
      }
    };
    initializePage();
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero settings={siteSettings} />
        <Services />
        <TireInventory settings={siteSettings} />
        <Reviews />
        <Contact settings={siteSettings} />
      </main>
      <Footer settings={siteSettings} />
    </div>
  );
};

export default LandingPage;
